import type { FaireProductEntity } from "../../entity_types/product";

export const p_vnpuf6r69n: FaireProductEntity = {
  token: "p_vnpuf6r69n",
  type: "product",
  name: "Navy Stripe Tissue Paper",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d54c0e7841aa1a0cafbea58e28df6b97fdb9d07fb04b8ccf2c312a49df47c82a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a14c88521ab61193fb32f43e15d1bc24ea77da02165d98a087e21164c002c030.png",
    "https://cdn.faire.com/fastly/c0ce883cfcad7c854b37b93a363f38d1eca3c4ca33bfc1ec453e9defb69004dd.png",
    "https://cdn.faire.com/fastly/df5b7badce3ee91277165833a085f6cdb6fa50532c2726b6a279aa2f32673551.png",
  ],
  priceDollars: 4,
  description:
    "Each package contains 10 generously sized sheets of tissue paper to mix and match with our coordinating gift bags (sold separately). The weirdly best part—unused tissue easily slides back into the envelope for organized storage, no more loose, crinkled foldy piles!",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:56.577Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
